
export default {
  simplePlaceSearch: {
    'noPlaceFound': 'A megadott tartalomhoz nem található hely',
    'openSidebarToSeeRouteDetails': 'Nyissa meg az oldalsávot az útvonal részleteinek megtekintéséhez',
    'unknownSearchPlaceError': 'Ismeretlen helykeresési hiba'
  }
}
